import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

/**
 * Slider component
 */
export default class HeroSlider extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HeroSlider',
    refs: ['slider', 'prev', 'next', 'pagination'],
  };

  /**
   *
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Pagination],
      slidesPerView: 1,
      grabCursor: true,
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
      },
    });
  }
}
